import Singleaddshow from "../../components/Singleitem_show";
import { useEffect, useState } from "react";
import { useGetSingleItemByUserQuery } from "../../features/shop/shopApiSlice";
import { useSelector } from "react-redux";

const Singleitemview = () => {
  const [singleitemadd, setSingleitemadd] = useState();
  const [shows, setShows] = useState(false);
  const { name } = useSelector((state) => state.user);

  const { data: itemData, isLoading: loading } = useGetSingleItemByUserQuery(name?._id, {
    skip: !name?._id
  });

  useEffect(() => {
    if (itemData?.success) {
      setSingleitemadd(itemData?.data?.ShopItems);
    }
  }, [itemData]);


  return (
    <>
      <Singleaddshow
        postlink="/post-single-ad"
        singleitemadd={singleitemadd}
        navurl="/singleitem-show/"
        loading={loading}
        shows={shows}
        setShows={setShows}
        setSingleitemadd={setSingleitemadd}
      />
    </>
  );
};

export default Singleitemview;
